// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__ywkTr","logo":"Navbar_logo__2A9-s","divider":"Navbar_divider__6GcjI","link":"Navbar_link__J6aZr"};